import { getRootEntity } from 'client/reducers/pageReducer'
import { useManagement, usePage } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { BaseEntityBodyInterface } from 'common/types/entities/EntityInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { isCustomDomain } from 'src/editor/shared/utils/is-custom-domain'
import { Tooltip } from 'src/shared/components/tooltip'
import { useUpdateProp } from '../../hooks/useUpdateProps'

export const Affiliate = <T extends BaseEntityBodyInterface>() => {
  const { t } = useTranslation()
  const entity = usePage(getRootEntity) as T
  const isUserFreemium = useManagement(managementSelectors.isUserFreemium)
  const updateProp = useUpdateProp<T>(entity)
  const isWhiteLabel = isCustomDomain()

  const toggleAffiliateBadge = (checked: boolean) => {
    if (isUserFreemium) {
      return
    }
    updateProp('isAffiliateBadgeVisible')(checked)
  }

  return (
    !isWhiteLabel && (
      <>
        <GroupTitle
          className="flex"
          afterChildren={
            <Tooltip
              message={t('entity_settings.body.affiliate.badge.description')}
            />
          }
        >
          entity_settings.body.affiliate.title
        </GroupTitle>
        <div className="mb-5 flex items-center">
          <CheckboxControl
            update={toggleAffiliateBadge}
            label="entity_settings.body.affiliate.badge.label"
            tooltipText={
              (isUserFreemium &&
                'entity_settings.body.affiliate.badge.freemium_help_message') ||
              ''
            }
            value={isUserFreemium || entity?.isAffiliateBadgeVisible}
            disabled={isUserFreemium}
          />
        </div>
      </>
    )
  )
}
